import React from 'react';
import { isUndefined } from 'lodash';

export const getCellBackgroundColor = (config, cell, heatMapValueOf) =>
   isHeatMapCell(config, cell) ? heatMapValueOf(cell.value) : 'transparent';

export const conditionalCellRenderer = (config, cell) => {
   const heatBubbleCss = getHeatMapBubble(config, cell);

   return heatBubbleCss === '' ? (
      cell.render('Cell')
   ) : (
      <div className={heatBubbleCss}>{cell.render('Cell')}</div>
   );
};

export const isDisplayTooltip = (cell) =>
   !isUndefined(cell.value) &&
   cell.column.tooltip &&
   cell.column.tooltip.isShowTooltip;

const getHeatMapBubble = (config, cell) =>
   isHeatMapCell(config, cell) && !isUndefined(cell.value)
      ? ` heatmap-bubble ${cell.value}`
      : '';

const isHeatMapCell = (config, cell) =>
   config.configHeatMap &&
   config.configHeatMap.heatMapColumns &&
   !cell.isAggregated &&
   !cell.isPlaceholder &&
   config.configHeatMap.heatMapColumns.indexOf(cell.column.id) > -1;
